//#region src/dates/is-iso-string.ts
var e = /^\d{4}-\d{2}-\d{2}(T\d{2}:\d{2}:\d{2}(\.\d{1,3})?(Z|[+-]\d{2}:?\d{2})?)?$/, t = (t) => {
	if (!e.test(t)) return !1;
	let n = new Date(t);
	if (isNaN(n.getTime())) return !1;
	if (!t.includes("T") || t.endsWith("Z")) {
		let e = n.toISOString(), r = t.split("T")[0];
		return r ? e.startsWith(r) : !1;
	}
	return !0;
}, n = (e, t) => r(e, t, 0), r = (e, n, i = 0) => {
	let a = n?.deep ?? !1, o = n?.deepArrays ?? !1, s = n?.maxDepth ?? 50;
	if (i >= s) throw Error(`Maximum recursion depth of ${s} exceeded in parseISOStrings. This may indicate circular references or deeply nested data structures.`);
	let c = n?.predicate;
	if (typeof e == "string") return t(e) ? c && !c(e) ? e : new Date(e) : e;
	if (e == null) return e;
	if (Array.isArray(e)) return e.map((e) => typeof e == "string" && t(e) ? c && !c(e) ? e : new Date(e) : o && (typeof e == "object" || Array.isArray(e)) ? r(e, n, i + 1) : e);
	if (e instanceof Date) return e;
	if (typeof e == "object" && e) {
		let o = {};
		for (let s in e) {
			let l = e[s];
			o[s] = c && !c(l, s, e) ? l : typeof l == "string" && t(l) ? new Date(l) : a && typeof l == "object" && l ? r(l, n, i + 1) : l;
		}
		return o;
	}
	return e;
};
//#endregion
export { t as isISOString, n as parseISOStrings };

//# sourceMappingURL=index.es.js.map